import { Component } from '@angular/core';

@Component({
  selector: 'app-home-actions',
  templateUrl: './home-actions.component.html',
  styleUrls: ['./home-actions.component.scss']
})
export class HomeActionsComponent {

}
